/**
 * /tenants/$slug/compliance/controls/$catalogId — redirect to Posture.
 * See ../index.tsx for why the old addresses are kept.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/compliance/controls/$catalogId",
)({
  // validateSearch is an identity pass-through, and it is load-bearing:
  // without it the router drops every param this route does not declare,
  // so a saved "not met, critical only" link would land unfiltered. The
  // target route validates them properly.
  validateSearch: (raw: Record<string, unknown>) => raw,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/tenants/$slug/posture/compliance/controls/$catalogId",
      params,
      search: (prev: Record<string, unknown>) => ({ ...prev, ...search }),
      replace: true,
    });
  },
});
